// synced from loomweb blocks/file-search-block-view.tsx (de-Tailwind'd).
/**
 * File-search block. Faithful to loomweb's FileSearchBlockView: header (icon +
 * "File Search" + in-progress / Done state), an optional active-text row, the
 * pattern + path info, and a result panel. Tailwind classes are replaced by
 * namespaced `replay-*` CSS; lucide icons by the local inline-SVG set.
 */
import type { JSX } from "react";
import type { FileSearchBlock } from "@shared/loom-message-block";
import { FolderSearchIcon, LoaderIcon, CheckIcon } from "./icons";
import { ToolResultPanel } from "./tool-result-panel";

export function FileSearchBlockView({ block }: { block: FileSearchBlock }): JSX.Element {
  const isInProgress = block.status === "in_progress" || block.status === "streaming";
  const isCompleted = block.status === "completed";

  return (
    <div className="replay-block replay-file-search-block">
      <div className="replay-block-head">
        <FolderSearchIcon className="replay-icon replay-text-cyan" />
        <span className="replay-block-label">File Search</span>
        {isInProgress && (
          <span className="replay-block-flag replay-text-primary">
            <LoaderIcon className="replay-icon-xs replay-spin" />
          </span>
        )}
        {isCompleted && (
          <span className="replay-block-flag replay-text-success">
            <CheckIcon className="replay-icon-xs" />
            Done
          </span>
        )}
      </div>

      {isInProgress && block.activeText !== undefined && block.activeText.length > 0 && (
        <div className="replay-block-active">{block.activeText}</div>
      )}

      <div className="replay-search-info">
        <div className="replay-search-row">
          <span className="replay-text-muted">Pattern:</span>
          <code className="replay-search-pattern">{block.pattern}</code>
        </div>
        <div className="replay-search-row replay-search-row-scroll">
          <span className="replay-text-muted">Path:</span>
          <span className="replay-mono">
            {block.path !== null && block.path.length > 0 ? block.path : "Current directory"}
          </span>
        </div>
      </div>

      {block.results !== undefined && (
        <ToolResultPanel
          title={`Results: ${block.results.length}`}
          content={block.results.join("\n")}
          copyAriaLabel="复制搜索结果"
          defaultCollapsed={false}
          status={block.status}
        />
      )}
    </div>
  );
}
